export default __webpack_public_path__ + "static/media/profit.9f377cd4.wav";